(function () {
  function closeSort(sort) {
    var button = sort.querySelector('.knytra-sort__button');

    sort.classList.remove('is-open');
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  function closeAllSorts(except) {
    document.querySelectorAll('[data-knytra-sort].is-open').forEach(function (sort) {
      if (sort !== except) closeSort(sort);
    });
  }

  function focusOption(sort, direction) {
    var options = Array.prototype.slice.call(sort.querySelectorAll('.knytra-sort__option'));
    var active = document.activeElement;
    var index = options.indexOf(active);

    if (index === -1) {
      index = options.findIndex(function (option) {
        return option.classList.contains('is-selected');
      });
    }

    var next = direction === 'prev' ? index - 1 : index + 1;
    if (next < 0) next = options.length - 1;
    if (next >= options.length) next = 0;
    if (options[next]) options[next].focus();
  }

  function setSortValue(sort, option) {
    var select = sort.querySelector('select');
    var label = sort.querySelector('[data-knytra-sort-label]');

    if (!select || !option) return;

    select.value = option.dataset.value;
    if (label) label.textContent = option.textContent.trim();

    sort.querySelectorAll('.knytra-sort__option').forEach(function (item) {
      var isSelected = item === option;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    closeSort(sort);
    select.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function initSort(sort) {
    if (sort.dataset.knytraSortReady === 'true') return;
    sort.dataset.knytraSortReady = 'true';

    var button = sort.querySelector('.knytra-sort__button');
    var options = sort.querySelectorAll('.knytra-sort__option');

    if (!button || !options.length) return;

    button.addEventListener('click', function () {
      var isOpen = sort.classList.contains('is-open');
      closeAllSorts(sort);
      sort.classList.toggle('is-open', !isOpen);
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        closeAllSorts(sort);
        sort.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        focusOption(sort, 'next');
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        setSortValue(sort, option);
        button.focus();
      });

      option.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setSortValue(sort, option);
          button.focus();
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          focusOption(sort, 'next');
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          focusOption(sort, 'prev');
        }

        if (event.key === 'Escape') {
          closeSort(sort);
          button.focus();
        }
      });
    });
  }

  function initAllSorts(root) {
    (root || document).querySelectorAll('[data-knytra-sort]').forEach(initSort);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-knytra-sort]')) closeAllSorts();
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') closeAllSorts();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initAllSorts(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllSorts(event.target);
  });
})();
